import React from 'react';
import { FloatingParticles } from './components/FloatingParticles';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutionsSection } from './components/FailedSolutionsSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsForSection } from './components/WhoIsForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
export function App() {
  return <div className="min-h-screen bg-[#0a0e27] text-slate-50 selection:bg-blue-500/30 selection:text-blue-200 relative" data-id="element-0">
      {/* Ambient Background */}
      <FloatingParticles data-id="element-1" />

      {/* Main Content */}
      <main className="relative z-10 overflow-hidden" data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <FailedSolutionsSection data-id="element-5" />
        <MechanismSection data-id="element-6" />
        <WhatYouGetSection data-id="element-7" />
        <WhoIsForSection data-id="element-8" />
        <HowItWorksSection data-id="element-9" />
        <ProofSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <OfferSection data-id="element-12" />
      </main>

      {/* Footer */}
      <footer id="footer" className="relative z-10 py-8 text-center text-gray-500 text-sm border-t border-white/5 bg-[#0a0e27]" data-id="element-13">
        <p data-id="element-14">
          © {new Date().getFullYear()} El Fin del Insomnio por Ansiedad. Todos
          los derechos reservados.
        </p>
      </footer>
    </div>;
}